import { t } from 'javascripts/utils/withTranslation';

export default class CommentToggle {
  constructor($toggle) {
    this.$toggle = $toggle;
    this.$toggleText = this.$toggle.querySelector('.icon-link__text');
    this.$comments = document.querySelectorAll('.comment');
    this.isAllClosed = true;

    this.$toggle.addEventListener('click', this.toggleComments);
  }

  toggleComments = () => {
    if (this.isAllClosed) {
      this.openComments();
      this.isAllClosed = false;
      this.$toggleText.innerHTML = t('Alle Kommentare schließen');
    } else {
      this.closeComments();
      this.isAllClosed = true;
      this.$toggleText.innerHTML = t('Alle Kommentare öffnen');
    }

    this.$toggle.blur();
  }

  openComments() {
    this.$comments.forEach(($comment) => {
      $comment.classList.add('comment--collapsed');
    });
  }

  closeComments() {
    this.$comments.forEach(($comment) => {
      $comment.classList.remove('comment--collapsed');
    });
  }
}
